const Cachekey_StatusUpdateDatetimeoldShowmodal =
  "status_update_datetime_old_showmodal";

const Cachekey_StatusUpdateDatetimeoldPeticion =
  "status_update_datetime_old_peticion";

//-----------------------------------------------------------------
export const Cache_Remove_StatusUpdateDatetimeoldShowmodal = () => {
  sessionStorage.removeItem(Cachekey_StatusUpdateDatetimeoldShowmodal);
};

export const Cache_Set_StatusUpdateDatetimeoldShowmodal = (
  datetime_current: Date
) => {
  sessionStorage.setItem(
    Cachekey_StatusUpdateDatetimeoldShowmodal,
    datetime_current.toISOString()
  );
};

export const Cache_Get_StatusUpdateDatetimeoldShowmodal = () => {
  let datetime_old = undefined;
  const cache_datetime_old = sessionStorage.getItem(
    Cachekey_StatusUpdateDatetimeoldShowmodal
  );
  if (cache_datetime_old) datetime_old = new Date(cache_datetime_old); // reconstruyes el objeto Date

  return datetime_old;
};

//-----------------------------------------------------------------
export const Cache_Remove_StatusUpdateDatetimeoldPeticion = () => {
  sessionStorage.removeItem(Cachekey_StatusUpdateDatetimeoldPeticion);
};

export const Cache_Set_StatusUpdateDatetimeoldPeticion = (
  datetime_current: Date
) => {
  sessionStorage.setItem(
    Cachekey_StatusUpdateDatetimeoldPeticion,
    datetime_current.toISOString()
  );
};

export const Cache_Get_StatusUpdateDatetimeoldPeticion = () => {
  let datetime_old = undefined;
  const cache_datetime_old = sessionStorage.getItem(
    Cachekey_StatusUpdateDatetimeoldPeticion
  );
  if (cache_datetime_old) datetime_old = new Date(cache_datetime_old); // reconstruyes el objeto Date

  return datetime_old;
};
